import {setup as setupNewRelic} from './tracking/newrelic';
import {setup as setupEvents} from './tracking/events';
import {setup as setupActionTracker} from './tracking/action_tracker';

function setup() {
  setupNewRelic();
  setupActionTracker();
  setupEvents();
}

// Start tracking as soon as page loaded
window.addEventListener('load', setup, false);
